import React from 'react';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  active: { label: 'Active', color: 'success' },
  inactive: { label: 'Inactive', color: 'error' },
  pending: { label: 'Pending', color: 'warning' },
  approved: { label: 'Approved', color: 'success' },
  uploaded: { label: 'Uploaded', color: 'info' },
  assigned: { label: 'Assigned', color: 'info' },
  selected: { label: 'Selected', color: 'info' },
  draft: { label: 'Draft', color: 'default' },
};

/**
 * Consistent status chip for content bank tables.
 */
export default function StatusBadge({ status }) {
  const normalized = String(status || 'active').toLowerCase();
  const config = STATUS_CONFIG[normalized] || {
    label: status || 'Unknown',
    color: 'default',
  };

  return (
    <Chip
      label={config.label}
      size="small"
      color={config.color}
      variant="outlined"
      sx={{
        fontWeight: 600,
        fontSize: '0.6875rem',
        textTransform: 'uppercase',
        height: 22,
      }}
    />
  );
}
